import React, { useEffect, useState } from "react";
import UserModeration, { StatusBadge } from "@/components/admin/UserModeration";
import api from "@/lib/api";
import { User, Shield, Mail } from "lucide-react";

export default function AdminAccounts() {
  const [users, setUsers] = useState([]);
  const [tab, setTab] = useState("accounts");

  const load = () => api.get("/admin/users").then((r) => setUsers(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-4xl">
      <h1 className="text-2xl font-bold text-white">Accounts & Participants</h1>
      <p className="text-sm text-white/50">Manage registered public accounts and tournament participants.</p>

      <div className="flex gap-2 mt-5 mb-4">
        {[["accounts", "Public Accounts"], ["participants", "Tournament Participants"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`accounts-tab-${k}`}
            className={`px-4 py-1.5 rounded-full text-sm font-semibold ${tab === k ? "bg-white text-black" : "card-surface text-white/60 hover:text-white"}`}>{l}</button>
        ))}
      </div>

      {tab === "accounts" ? (
        <div className="card-surface rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-white/40 border-b border-white/10">
                <th className="p-4 font-semibold">User</th>
                <th className="p-4 font-semibold hidden md:table-cell">Email</th>
                <th className="p-4 font-semibold">Role</th>
                <th className="p-4 font-semibold hidden lg:table-cell">Joined</th>
                <th className="p-4 font-semibold text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.user_id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                  <td className="p-4">
                    <div className="flex items-center gap-3">
                      {u.picture ? <img src={u.picture} alt="" className="w-8 h-8 rounded-full" /> : <span className="w-8 h-8 rounded-full bg-white/10 grid place-items-center"><User size={14} /></span>}
                      <span className="font-semibold text-white">{u.name}<StatusBadge u={u} /></span>
                    </div>
                  </td>
                  <td className="p-4 hidden md:table-cell text-white/60"><span className="flex items-center gap-1.5"><Mail size={13} /> {u.email}</span></td>
                  <td className="p-4">
                    {u.is_admin ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-semibold bg-[hsl(var(--accent))]/15 text-[hsl(var(--accent))]"><Shield size={11} /> Admin</span>
                    ) : (
                      <span className="px-2 py-0.5 rounded text-xs font-semibold bg-white/10 text-white/60">Member</span>
                    )}
                  </td>
                  <td className="p-4 hidden lg:table-cell text-white/50">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                  <td className="p-4"><UserModeration u={u} onChanged={load} /></td>
                </tr>
              ))}
              {users.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-white/40">No accounts yet.</td></tr>}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="card-surface rounded-xl p-10 text-center text-white/50">
          <Shield size={28} className="mx-auto mb-3 text-white/20" />
          Tournament participant management arrives with the full tournament builder. Registered teams and players will appear here.
        </div>
      )}
    </div>
  );
}
